import { render, staticRenderFns } from "./UpdateGroupParametersModal.vue?vue&type=template&id=2a6c0745&scoped=true&"
import script from "./UpdateGroupParametersModal.vue?vue&type=script&lang=js&"
export * from "./UpdateGroupParametersModal.vue?vue&type=script&lang=js&"
import style0 from "./UpdateGroupParametersModal.vue?vue&type=style&index=0&id=2a6c0745&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a6c0745",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCol,VForm,VRow,VTextField})
